import {interopDefault} from '@/utils/helpers'

const ActivitiesPage = () => interopDefault(import('@/pages/activities/ActivitiesPage'))
const ActivityPage = () => interopDefault(import('@/pages/activities/ActivityPage'))
const ActivityBookingPage = () => interopDefault(import('@/pages/activities/ActivityBookingPage'))
const ActivityConfirmationPage = () => interopDefault(import('@/pages/activities/ActivityConfirmationPage'))

export default [
    {
        path: '/search/activities',
        component: ActivitiesPage,
        name: 'activities',
        meta: {
            unwrapped: true,
            validate: route => !!route.query.cityId || !!route.query.countryId,
        },
    },
    {
        path: '/activity',
        component: ActivityPage,
        name: 'activity',
        beforeEnter: (to, from, next) => {
            if (!to.query.name) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.name,
        },
    },
    {
        path: '/activities/booking',
        component: ActivityBookingPage,
        name: 'activityBooking',
        beforeEnter: (to, from, next) => {
            if (!to.query.offerKey) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/activities/confirmation',
        component: ActivityConfirmationPage,
        name: 'activityConfirmation',
        beforeEnter: (to, from, next) => {
            if (!to.query.orderId) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
        },
    },
]
